module.exports = __webpack_public_path__ + "src/app/_content/MOTFonts/BMWMotorradOutlineW01-Rg.eot?c0eb2d3c4608d7cb813dba77326b6101";